















import { Component, Prop, Vue } from 'vue-property-decorator';
import truncateString from '@/utils/common/truncate';
import { Folder } from '@/resource/folder/folder.model';

@Component({
  components: {},
})
export default class FolderItemComponent extends Vue {
  @Prop({ required: true })
  folder: Folder;

  get truncateName() {
    return truncateString(this.folder.name, 12);
  }

  itemClick() {
    this.$emit('updateFolder', this.folder);
  }
}
